import { AnalyticSearchRequestDto } from 'src/generated/services/TFinancialApi';

/**
 * Utility function to sanitize form values by converting empty strings to null
 * This is required because the backend expects null values for empty filters, not empty strings
 *
 * Common issues this fixes:
 * - Empty strings ("") -> null
 * - Empty arrays ([]) -> null
 * - Nested empty objects with empty string properties
 * - Specific filter patterns like quarters="", months="", weeks="", days=""
 *
 * @param formValues - The form values object to sanitize
 * @returns Sanitized form values with empty strings converted to null
 */
export const sanitizeFormValues = (formValues: any): AnalyticSearchRequestDto => {
  const sanitizeObject = (obj: any): any => {
    if (obj === null || obj === undefined) return null;

    // Convert empty strings to null
    if (typeof obj === 'string') return obj === '' ? null : obj;

    // Convert empty arrays to null
    if (Array.isArray(obj)) return obj.length === 0 ? null : obj;

    // Recursively sanitize objects
    if (typeof obj === 'object') {
      const sanitized = {};
      for (const [key, value] of Object.entries(obj)) {
        sanitized[key] = sanitizeObject(value);
      }
      return sanitized;
    }

    return obj;
  };

  const sanitized = sanitizeObject(formValues) as AnalyticSearchRequestDto;

  return sanitized;
};
